import { useEffect, useState } from 'react';
import { userManager } from '../../auth/oidcConfig';
import { useTutorial } from '../../hooks/useTutorial';
import { TutorialOverlay } from './TutorialOverlay';

/**
 * Mounts the guided tutorial for the signed-in operator (issue #427).
 *
 * Progress is per operator, so the tour only starts once the OIDC subject is
 * known. Nothing renders when there is no tour left to show — the overlay is
 * pure onboarding and never sits in front of a working screen.
 */
export const TutorialGuide: React.FC = () => {
  const [userKey, setUserKey] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    userManager
      .getUser()
      .then((user) => {
        if (active && user?.profile?.sub) {
          setUserKey(user.profile.sub);
        }
      })
      .catch(() => {
        // No identity, no per-operator progress — skip onboarding rather than
        // risk showing one operator's tour to another.
      });
    return () => {
      active = false;
    };
  }, []);

  const { tour, step, position, total, rect, target, skip } = useTutorial(userKey);

  if (!tour || !step || !rect) {
    return null;
  }

  return (
    <TutorialOverlay
      title={tour.title}
      step={step}
      position={position}
      total={total}
      rect={rect}
      target={target}
      onSkip={skip}
    />
  );
};
